export default __webpack_public_path__ + "static/media/logo-webdev.a00560c3.svg";